import * as React from 'react'

import { TableStickyColumnWrapper } from '../Table/TableStickyColumnWrapper'
import FinancialsTable from './FinancialsTable'
import {
  FinancialsColumnDefinition,
  FinancialsRowDataType,
  FinancialsSubColumnDefinition,
  FinancialsSubRowDataType,
} from './types'

type FinancialsWidgetProps<
  RowDataType extends FinancialsRowDataType,
  ColumnDefinition extends FinancialsColumnDefinition<RowDataType>,
  SubColumnDefinition extends FinancialsSubRowDataType,
> = {
  children: React.ReactNode
  header?: React.ReactNode
  tableHead?: React.ReactNode
  tableFooter?: React.ReactNode
  data: RowDataType[]
  columns: ColumnDefinition[]
  hasStickyColumnWrapper?: boolean
  subColumns?: Record<string, FinancialsSubColumnDefinition<SubColumnDefinition>[]>
  isTableFixed?: boolean
  onVisibilityChange: (area: string, visibility: boolean) => void
}

export function FinancialsWidget<
  RowDataType extends FinancialsRowDataType,
  ColumnDefinition extends FinancialsColumnDefinition<RowDataType>,
  SubColumnDefinition extends FinancialsSubRowDataType,
>({
  children,
  tableHead,
  tableFooter,
  columns,
  subColumns,
  header,
  data,
  isTableFixed,
  hasStickyColumnWrapper,
  onVisibilityChange,
}: FinancialsWidgetProps<RowDataType, ColumnDefinition, SubColumnDefinition>) {
  const financialsTable = (
    <FinancialsTable
      tableHead={tableHead}
      tableFooter={tableFooter}
      data={data}
      columns={columns}
      subColumns={subColumns}
      isTableFixed={isTableFixed}
      onVisibilityChange={onVisibilityChange}
    />
  )
  return (
    <div className="js-financials-widget">
      <div className="mb-0.5 space-y-1.5">
        {header}
        {children}
      </div>
      {hasStickyColumnWrapper ? (
        <TableStickyColumnWrapper key={data[0]?.values.length ?? 0} hasBorder shouldScrollToEnd>
          {financialsTable}
        </TableStickyColumnWrapper>
      ) : (
        financialsTable
      )}
    </div>
  )
}
